// extracted by mini-css-extract-plugin
export var cardSelected = "_h6-2";
export var image = "_h6-1";
export var table = "_h6-0";